/**
 * Sweep bounds. They live with the module so deleting the folder takes the
 * knobs with it. Shore crash constants stay in `src/sim/constants.ts`.
 */
/** Hull-to-hull contacts resolved in one turn. Each impulse leaves the pair separating. */
export const BOAT_CONTACT_MAX = 6;
/**
 * Steps the fleet sweep takes across one turn. At the 300 km/h cap a hull covers
 * about 330 px in a turn, so 64 steps advance ~5 px against a 35 px hull.
 */
export const BOAT_SWEEP_STEPS = 64;
/** Bisections that refine the instant of contact. Fixed, so replay lands on the same number. */
export const BOAT_SWEEP_REFINEMENTS = 12;
/**
 * Fraction of the closing speed that must come back as separation at harshness 1.
 * Off-centre hits otherwise put the impulse into yaw and the hulls spin through
 * each other. 0 harshness returns the whole closing speed; 2 keeps none.
 */
export const BOAT_BOUNCE_KEEP = 0.45;
/** Extra pixels the hulls are set apart, so "just touching" does not read as overlap. */
export const BOAT_SKIN_PX = 4;
/**
 * Closing speed below which a boat-to-boat hit is a nudge: a racing incident, no penalty.
 * 5 m per turn, about 4.5 km/h of closing. Tunable.
 */
export const BOAT_NUDGE_CLOSING_PX = 50;
/**
 * Closing speed at or above which a hit is hard: the boat at fault stops dead, like a hard
 * shore crash. Between the two is a medium hit, the shore scrape's cost. 20 m per turn,
 * about 18 km/h of closing. Tunable.
 */
export const BOAT_HARD_CLOSING_PX = 200;
